import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import {
  Button,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DownloadIcon from '@mui/icons-material/Download';
import FolderIcon from '@mui/icons-material/Folder';
import BusinessIcon from '@mui/icons-material/Business';
import { ApiRequest } from 'GlobalFunctions';
import { ProjectConfig } from 'Global';

export default function BackupsList(props: any) {
  const { setLoading } = props;

  const [view, setView] = useState<'companies' | 'folders'>('companies');
  const [companies, setCompanies] = useState<any[]>([]);
  const [folders, setFolders] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);

  useEffect(() => {
    setLoading(false);
    loadCompanies();
  }, []);

  const loadCompanies = async () => {
    setLoading(true);
    await ApiRequest({
      url: '/backups/companies',
      method: 'get',
      headers: { ltkn: localStorage.getItem('ltkn') },
      setResponse: (response: any) => {
        setCompanies(response.list || []);
        setLoading(false);
      },
    });
  };

  const loadFolders = async (company: any) => {
    setSelectedCompany(company);
    setView('folders');
    setLoading(true);
    await ApiRequest({
      url: `/backups/folders/${company.company_id}`,
      method: 'get',
      headers: { ltkn: localStorage.getItem('ltkn') },
      setResponse: (response: any) => {
        setFolders(response.list || []);
        setLoading(false);
      },
    });
  };

  const handleDownload = (folder: any) => {
    const url = `${ProjectConfig.api_url}/backups/download/${selectedCompany.company_id}/${folder.date}/${folder.hour}`;
    window.open(url, '_blank');
  };

  const goBack = () => {
    setView('companies');
    setSelectedCompany(null);
    setFolders([]);
  };

  const formatHour = (hour: string) => {
    return hour.replace('-', ':');
  };

  return (
    <div id="Backups" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            {view === 'folders' && (
              <IconButton onClick={goBack} style={{ marginRight: 8 }}>
                <ArrowBackIcon />
              </IconButton>
            )}
            <div>
              <h2 className="h2_title">
                {view === 'companies' ? 'Backups' : `Backups - ${selectedCompany?.company_name}`}
              </h2>
              <span className="h2_subtitle">
                {view === 'companies'
                  ? 'Seleccione una empresa para ver sus backups'
                  : 'Carpetas de backup disponibles'}
              </span>
            </div>
          </div>
        </div>

        <Box className="box100">
          {view === 'companies' && (
            <List>
              {companies.map((company: any) => (
                <ListItem key={company.company_id} disablePadding>
                  <ListItemButton onClick={() => loadFolders(company)}>
                    <BusinessIcon sx={{ mr: 2, color: '#1D3B47' }} />
                    <ListItemText
                      primary={company.company_name}
                      secondary={`ID: ${company.company_id}`}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
              {companies.length === 0 && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ py: 4 }}>
                  No hay backups disponibles
                </Typography>
              )}
            </List>
          )}

          {view === 'folders' && (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Fecha</TableCell>
                    <TableCell>Hora</TableCell>
                    <TableCell>Archivos</TableCell>
                    <TableCell align="right">Descargar</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {folders.map((folder: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>
                        <FolderIcon sx={{ fontSize: 16, mr: 1, verticalAlign: 'middle', color: '#1D3B47' }} />
                        {folder.date}
                      </TableCell>
                      <TableCell>{formatHour(folder.hour)}</TableCell>
                      <TableCell>
                        {folder.files.map((file: string) => (
                          <Chip
                            key={file}
                            label={file}
                            size="small"
                            variant="outlined"
                            sx={{ mr: 0.5 }}
                          />
                        ))}
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          size="small"
                          variant="contained"
                          startIcon={<DownloadIcon />}
                          onClick={() => handleDownload(folder)}
                        >
                          ZIP
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                  {folders.length === 0 && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No hay backups para esta empresa
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </div>
    </div>
  );
}
